import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroPartes extends Filtro {
    tipo = 'selecao';
    exibicao = 'autocomplete';

    get label() {
        return 'Partes';
    }

    constructor(props) {
        super({ ...props, exibeTotalizadores: false });

        makeObservable(this, {
            opcoesSelect: computed,
            carregandoDadosComplementares: computed
        });
    }

    get opcoesSelect() {
        let opcoes = [];
        let processos = this.store.processosFiltrados;
        let valorOpcao;

        for (const registro of processos) {
            valorOpcao = this.getValorOpcao(registro);
            if (valorOpcao) {
                for (const valorArray of valorOpcao) {
                    opcoes.push({
                        texto: (this.getDescricao(valorArray) || '').trim(),
                        icone: this.getIconeOpcao(registro, valorArray),
                        cor: this.getCorOpcao(registro, valorArray),
                        valor: valorArray
                    });
                }
            }
        }

        opcoes = opcoes.filter((opcao, index, self) => index === self.findIndex((o) => o.texto === opcao.texto));
        opcoes.sort(this.sort);

        return opcoes;
    }

    getValorOpcao(registro) {
        let retorno = [];
        if (this.store.mapaProcessosPartes) {
            let partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];
            retorno = partesProcesso ? partesProcesso.partes : [];
        }
        return retorno;
    }

    getDescricao(valor) {
        return valor ? valor.nome + (valor.registroComplementar ? ' (' + valor.registroComplementar + ')' : '') : '';
    }

    equals(valor1, valor2) {
        return valor1 && valor2 && valor1.nome && valor1.nome.localeCompare(valor2.nome) === 0;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    renderCarregando() {
        return this.renderCircularProgress('partes dos processos');
    }
}
